import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { IMountingPlanFilter } from "../models/filters/mountingPlanFilter";
import { IMountingPlanForm } from "../models/forms/mountingPlanForm";
import { IMountingPlanPDTO } from "../models/dtos/mountingPlanPDTO";

// Service for Mounting Plan operations
export default class MountingPlanService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/MountingPlan";

    protected static override getUrlFilter<F extends IMountingPlanFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.buildingId != undefined)
                url += `&BuildingId=${filter.buildingId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IMountingPlanForm):IMountingPlanPDTO {
        const dto = super.toDTO(obj) as IMountingPlanPDTO;
        return dto;
    }
}